<script>
  export let width;
</script>

<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="700 300 400 350" width={width}>
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }

      .cls-2 {
        fill: #fff;
      }

      .cls-3 {
        clip-path: url(#clip-path);
      }
    </style>
    <clipPath id="clip-path">
      <path class="cls-1" d="M919.55,620.91,1036.2,306.17a2.74,2.74,0,0,0-2.75-4h-20a6.5,6.5,0,0,0-5.68,4L891.17,620.91a2.74,2.74,0,0,0,2.75,4h20A6.5,6.5,0,0,0,919.55,620.91Z"/>
    </clipPath>
  </defs>
  <title>VH Logo</title>
  <g>
    <path class="cls-2" d="M753.57,306.74,869.67,620c.92,2.49-.48,4.52-3.14,4.52H847.77a7.43,7.43,0,0,1-6.49-4.52L725.18,306.74c-.92-2.49.48-4.52,3.14-4.52h18.75A7.43,7.43,0,0,1,753.57,306.74Z"/>
    <path class="cls-2" d="M801.29,306.74,894,556.1c.93,2.49-.48,4.52-3.14,4.52H872.14a7.44,7.44,0,0,1-6.5-4.52L772.9,306.74c-.93-2.49.48-4.52,3.14-4.52h18.75A7.44,7.44,0,0,1,801.29,306.74Z"/>
    <path class="cls-2" d="M871.77,620.34,988,306.73c.92-2.49-.48-4.52-3.14-4.52H966.1a7.43,7.43,0,0,0-6.49,4.52L843.38,620.34c-.92,2.49.48,4.52,3.14,4.52h18.75A7.43,7.43,0,0,0,871.77,620.34Z"/>
    <path class="cls-2" d="M968.49,620.34l116.23-313.61c.92-2.49-.48-4.52-3.14-4.52h-18.75a7.43,7.43,0,0,0-6.49,4.52L940.1,620.34c-.92,2.49.48,4.52,3.14,4.52H962A7.43,7.43,0,0,0,968.49,620.34Z"/>
    <g class="cls-3">
      <g>
        <path class="cls-2" d="M919.77,620.35l49-132.13c.92-2.49-.48-4.52-3.14-4.52H946.84a7.43,7.43,0,0,0-6.49,4.52l-49,132.13c-.92,2.49.48,4.52,3.14,4.52h18.75A7.43,7.43,0,0,0,919.77,620.35Z"/>
        <path class="cls-2" d="M979.39,459.08l56.5-152.46c.92-2.49-.48-4.52-3.14-4.52H1014a7.43,7.43,0,0,0-6.49,4.52L951,459.08c-.92,2.49.48,4.52,3.14,4.52H972.9A7.43,7.43,0,0,0,979.39,459.08Z"/>
      </g>
    </g>
  </g>
</svg>
